import Firebase, { mergeSnapshotChangesIntoArray } from './Firebase';

export default Firebase;
export { mergeSnapshotChangesIntoArray };


